import './impressum.css';
import Footer from '../footer/Footer';
import logo from '../../assets/Logo.webp';

const Impressum = ({ onShowDatenschutz }) => {
    return (
        <>
            
            <div className='impressum'>
                
                <div className="impressumContainer">
                    <a className='logoClass'  href='/'><img src={logo} alt="logo" /></a>
                    
                    <h1>Impressum</h1>
                    
                    <h2>Angaben gemäß § 5 DDG</h2>
                    
                    <div className="contactInfo">
                        <p>Eva-Christin List</p>
                        <p>Kommunikationsberaterin</p>
                        <p>Am Graskamp 23</p>
                        <p>48531 Nordhorn</p>
                    </div>
                    
                    <h3>Kontakt</h3>
                    <div className="contactDetails">
                        <p>Telefon: 05921 7058150</p>
                        <p>E-Mail: kontakt(at)evalist.de</p>
                    </div>
                    
                    <h3>Redaktionell Verantwortlich gemäß § 55 Abs. 2 RStV</h3>
                    <div className="editorialInfo">
                        <p>Eva-Christin List</p>
                        <p>Am Graskamp 23</p>
                        <p>48531 Nordhorn</p>
                    </div>
                    
                    <h3>Verbraucher­streit­beilegung / Universalschlichtungsstelle</h3>
                    <p className='ImpresumText'>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
                    
                    <h3>Hinweis auf Markenschutz</h3>
                    <p className='ImpresumText'>Mental Media Score® ist eine eingetragene Marke von Eva-Christin List.</p>
                </div>
                
                <Footer 
                    currentPage="impressum"
                    onShowImpressum={() => {}} // Empty function for current page
                    onShowDatenschutz={onShowDatenschutz} // Direct navigation to Datenschutz
                />
            </div>
        </>
    )
}

export default Impressum;